export enum HTTPMethods {
  Get = 'get',
  Post = 'post',
  Put = 'put',
  Delete = 'delete',
  Patch = 'patch',
}

export const BLACKLIST_AUTH_PATH = ['/master/', '/onboarding/', '/branch/'];
